import { computed, provide } from "vue";
import { I as INJECTION_KEY_THEME } from "./constants-wIEKSp2G.mjs";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-DU4iP6Vu.mjs";
const _sfc_main = {
  __name: "NcThemeProvider",
  props: {
    /**
     * Enforce the dark theme for the content.
     */
    dark: {
      type: Boolean,
      default: false
    },
    /**
     * Enforce the light theme for the content
     */
    light: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const theme = computed(() => {
      if (props.dark) {
        return "dark";
      } else if (props.light) {
        return "light";
      }
      return "";
    });
    provide(INJECTION_KEY_THEME, theme);
    return { __sfc: true, props, theme };
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", _vm._b({}, "div", _vm._d({}, [`data-theme-${_setup.theme}`, _setup.theme])), [_vm._t("default")], 2);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const NcThemeProvider = __component__.exports;
export {
  NcThemeProvider as N
};
//# sourceMappingURL=NcThemeProvider-BA_zMjAf.mjs.map
